import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
import CPage from '@/views/CPage.vue';
import composition from '@/composition';
import HeadView from '@/components/channel/head-view.vue';
import AdvView from '@/components/channel/adv-view.vue';
import TopicView from '@/components/channel/topic-view.vue';
import ChannelList from '@/components/channel/channel-list.vue';
export default {
  setup(__props) {
    const {
      ref,
      getQueryString,
      request,
      store,
      wxShare
    } = composition();
    const id = getQueryString().id;
    const categoryModel = ref({});
    const advertisement = ref({});
    const categoryType = ref('');
    request.getTimelineCategory(id).then(res => {
      window.zmyCollectionOpenActivityH5(id);
      categoryModel.value = res.data;
      advertisement.value = res.advertisement;
      categoryType.value = res.data.type;
      store.commit('setPageInfo', {
        pageType: pageType(),
        id: categoryModel.value.id
      });
      let title = res.data.name;
      let desc = '同城友圈-分享我的趣味生活';

      if (categoryType.value == 'NEIGHBOR') {
        // 友邻
        desc = '友邻-分享我的社区新鲜事';
      } // 特殊处理


      if (id == 355) {
        // 50公里徒步
        title = '徒步打卡、点歌、高清图片直播，徒步一站式互动社区';
        desc = '今天的“徒步人”都在这里打卡';
      }

      wxShare(title, desc, res.data.icon || 'https://content.foshanplus.cn/foshanlogo.png');

      _poc_channelPage(title, id);
    });
    setTimeout(() => {
      if (localStorage.getItem('_user_id')) {
        // eslint-disable-next-line no-undef
        qaplus.event.setMetaInfo(localStorage.getItem('_user_id')); // eslint-disable-next-line no-undef

        pocplus.event.config('user_unique_id', localStorage.getItem('_user_id'));
      }
    }, 1000);

    function _poc_channelPage(title, id) {
      // [埋点] 社区页访问
      let _poc_event_params = {
        channel_id: id,
        channel_name: title
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('circles_page', 2001, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_channel', _poc_event_params);
    }

    const activeName = ref(0);
    const types = ref([{
      name: '最新',
      order: ''
    }, {
      name: '最热',
      order: 'hotCount'
    }]); // 页面类型

    const pageType = () => {
      // 如果是音频，当作佛山街
      const pageTypeList = {
        MOMENT: 1,
        NEIGHBOR: 10,
        BROADCAST: 1
      };
      return pageTypeList[categoryType.value];
    };

    store.dispatch('_initApp');
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(CPage, {
        model: categoryModel.value,
        showPublish: true
      }, {
        main: _withCtx(() => [_createVNode(HeadView, {
          model: categoryModel.value,
          isCityBoard: _unref(id) == 11
        }, null, 8, ["model", "isCityBoard"]), _createVNode(AdvView, {
          model: advertisement.value
        }, null, 8, ["model"]), categoryModel.value.id ? (_openBlock(), _createBlock(TopicView, {
          key: 0,
          model: categoryModel.value
        }, null, 8, ["model"])) : _createCommentVNode("", true), _createVNode(_unref(_Tabs), {
          active: activeName.value,
          "onUpdate:active": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          "line-width": "0",
          swipeable: "",
          shrink: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item, index) => {
            return _openBlock(), _createBlock(_unref(_Tab), {
              title: item.name,
              name: index,
              key: index
            }, {
              default: _withCtx(() => [_createVNode(ChannelList, {
                order: item.order,
                cid: categoryModel.value.id,
                type: categoryType.value,
                isCityBoard: _unref(id) == 11
              }, null, 8, ["order", "cid", "type", "isCityBoard"])]),
              _: 2
            }, 1032, ["title", "name"]);
          }), 128))]),
          _: 1
        }, 8, ["active"])]),
        _: 1
      }, 8, ["model"]);
    };
  }

};